import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GlobalConstants } from '../../../common/constants/global.constant';

@Component({
  selector: 'iposcen-ipos-help-oda',
  templateUrl: './ipos-help-oda.component.html',
  styleUrls: ['./ipos-help-oda.component.scss']
})
export class IposHelpOdaComponent implements OnInit {
  @Output() readonly sideNav = new EventEmitter();
  @Input() sideNavData;
  @ViewChild('facttag') facttag: ElementRef;
  @ViewChild('storeLogo') storeLogo: ElementRef;
  @ViewChild('promoContent') promoContent: ElementRef;
  @ViewChild('bannerCarousel') bannerCarousel: ElementRef;
  @ViewChild('segments') segments: ElementRef;
  @ViewChild('priceContent') priceContent: ElementRef;
  @ViewChild('idleExp') idleExp: ElementRef;
  @ViewChild('compSkuInfo') compSkuInfo: ElementRef;
  @ViewChild('settings') settings: ElementRef;
  @ViewChild('chromebook') chromebook: ElementRef;
  skuMappingPrecedenceText = GlobalConstants.PROMO_FACTTAG_SKU_DESC;
  promoFactTagvisibilityText = GlobalConstants.PROMO_FACTTAG_VISIBILITY_DESC;
  constructor() { }

  ngOnInit(): void {
  }

  navigate(section) {
    this.sideNav.emit(['assetLibrary', '', section]);
  }

  change(data) {
    if (data === 'facttag') {
      setTimeout(() => {
        this.facttag.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'storeLogo') {
      setTimeout(() => {
        this.storeLogo.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'promoContent') {
      setTimeout(() => {
        this.promoContent.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'bannerCarousel') {
      setTimeout(() => {
        this.bannerCarousel.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'segments') {
      setTimeout(() => {
        this.segments.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'priceContent') {
      setTimeout(() => {
        this.priceContent.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'idleExp') {
      setTimeout(() => {
        this.idleExp.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'compSkuInfo') {
      setTimeout(() => {
        this.compSkuInfo.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'settings') {
      setTimeout(() => {
        this.settings.nativeElement.scrollIntoView();
      }, 0);
    } else if (data === 'chromebook') {
      setTimeout(() => {
        this.chromebook.nativeElement.scrollIntoView();
      }, 0);
    }
  }

}
